<template>

<div class="field" v-on:click="onClick">

    <div class="field-name">{{ item.lang.name }}</div>

    <div class="field-category">
        <span v-for="(category, index) in categories" :key="index" :data-name="category">{{ category }}</span>
    </div>

    <div class="field-description">{{ item.lang.description }}</div>

</div>

</template>

<script>

export default {

	props: ['item'],

    computed: {

        categories: function() {

            return this.$_.isArray(this.item.lang.category) ? this.item.lang.category : [this.item.lang.category]

        }

    },

    methods: {

        onClick: function() {

            this.$emit('click', this.item.key)

        }

    }

}

</script>

<style scoped>

.field {
    padding: 15px 15px;
    border-bottom: 1px solid rgb(54, 97, 119);
    cursor: pointer;
}

.is-mobile .field {
    border-bottom: 1px solid #eee;
}

.is-desktop .field:hover {
    background-color: rgba(255, 255, 255, 0.05);
}

.field-name {
    font-weight: 500;
    color: #fff;
    line-height: 20px;
    font-size: 16px;
}

.is-mobile .field-name {
    color: #343434;
}

.field-category {
    display: flex;
    gap: 4px;
    margin-top: 2px;
}

.field-category span {
    font-weight: 500;
    line-height: 12px;
    font-size: 12px;
    border-radius: 4px;
    padding: 2px 4px;
    color: #0a2b3d;
}

.field-category span[data-name="User"] {
    background-color: #E9C46A;
}

.field-category span[data-name="Game"] {
    background-color: #CBA6F7;
}

.field-category span[data-name="BGG"] {
    background-color: #6EC5E9;
}

.field-category span[data-name="Plays"] {
    background-color: #E9A6A6;
}

.field-category span[data-name="Collection"] {
    background-color: #90E0A9;
}

.field-category span[data-name="Ratings"] {
    background-color: #E27B64;
}

.field-description {
    font-weight: 400;
    color: #fff;
    font-size: 14px;
    line-height: 18px;
    opacity: 0.8;
    margin-top: 4px;
}

.is-mobile .field-description {
    color: #343434;
}

</style>